import { t } from "@/i18n-js/instance";
import { Typography } from "@/react/components/shared/uikit/Typography";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Icon } from "@circle-react-shared/Icon";

interface BooleanButtonProps {
  handleFeedback: (value: boolean) => void;
  isFeedbackGiven?: boolean | null;
  value: boolean | null;
}

export const BooleanButton = ({
  value,
  handleFeedback,
  isFeedbackGiven = null,
}: BooleanButtonProps) => (
  <>
    <button
      className={classNames(
        "w-full rounded-3xl border px-6 py-[3px] align-baseline font-medium",
        {
          "text-dark border-gray-300 dark:border-gray-500":
            value === null || !value,
          "border-circle text-circle": value === true,
          "!cursor-not-allowed": isFeedbackGiven,
          "hover:border-secondary dark:hover:border-secondary":
            !isFeedbackGiven,
        },
      )}
      onClick={() => value !== true && handleFeedback(true)}
      type="button"
    >
      <Typography.LabelSm color="text-primary" weight="medium">
        {t("help_widget.post.feedback_yes")}
      </Typography.LabelSm>
      <Icon
        type="16-thumbs-up"
        size={16}
        className={classNames({
          "text-circle ml-1": value === true,
          "text-dark ml-1 dark:text-gray-500": value === null || !value,
        })}
      />
    </button>
    <button
      className={classNames(
        "w-full rounded-3xl border px-6 py-[3px] align-baseline font-medium",
        {
          "text-dark border-gray-300 dark:border-gray-500":
            value === null || value,
          "border-circle text-circle": value === false,
          "!cursor-not-allowed": isFeedbackGiven,
          "hover:border-secondary dark:hover:border-secondary":
            !isFeedbackGiven,
        },
      )}
      onClick={() => value !== false && handleFeedback(false)}
      type="button"
    >
      <Typography.LabelSm color="text-primary" weight="medium">
        {t("help_widget.post.feedback_no")}
      </Typography.LabelSm>
      <Icon
        type="16-thumbs-down"
        size={16}
        className={classNames({
          "text-circle ml-1": value === false,
          "text-dark ml-1 dark:text-gray-500": value === null || value,
        })}
      />
    </button>
  </>
);
